import React from "react";
import { Route } from "react-router-dom";
import { ROUTER_PATH } from "../common/constant";
// import PointHistories from "../components/pointHistories";
import ProfileInformationDetail from "../components/profileInformationDetail";
// import ProfileMembership from "../components/profileMembership";
import ProfileOrders from "../components/profileOrder";
import ProfileOrderDetail from "../components/profileOrderDetail";
import ProfileProductWish from "../components/profileProductWish";
import { IRouteModel } from "../models";
import {
  Events,
  Home,
  PageNotFound,
  PaymentReturn,
  PolicyAndGeneralTerms,
  ProductsCategory,
  ShoppingCart,
  SpecialMattress,
  StoreAgency,
} from "../screens";
import Authentication from "../screens/Auth";
import Checkout from "../screens/Checkout";
import policyAndGeneralTermDetail from "../screens/PolicyAndGeneralTerms/policyAndGeneralTermDetail";
import Product from "../screens/Products";
import Profile from "../screens/Profile";
import Topic from "../screens/Topic";
import Warranty from "../screens/Warranty";
import LocalizedSwitch from "./localizedSwitch";
import LuckyWheel from "../screens/LuckyWheel";
import LuckyWheelSummary from "../screens/LuckyWheel/summary";
import VoucherLucky from "../screens/EventVoucherLucky";
// import { getAccessToken } from "../services/profile"

let _routes: IRouteModel[] = [
  {
    path: ROUTER_PATH.HOME,
    component: Home,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.PRODUCT,
    component: Product,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.PRODUCT_DETAIL_DEFAULT,
    component: Product,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.PRODUCTS_CATEGORY,
    component: ProductsCategory,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.SPECIAL_MATTRESS,
    component: SpecialMattress,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.SEARCH,
    component: ProductsCategory,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.CHECKOUT,
    component: Checkout,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.CART,
    component: ShoppingCart,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.SIGN_IN,
    component: Authentication,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.SIGN_UP,
    component: Authentication,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.CONFIRM_OTP,
    component: Authentication,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.STORE_AGENCY,
    component: StoreAgency,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.EVENT,
    component: Events,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.TOPIC_DETAIL,
    component: Topic,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.POLICY_AND_GENERAL_TERMS,
    component: PolicyAndGeneralTerms,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.POLICY_AND_GENERAL_TERM_DETAIL,
    component: policyAndGeneralTermDetail,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.WARRANTY,
    component: Warranty,
    exact: false,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.FORGOT_PASSWORD,
    component: Authentication,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.PROFILE,
    component: Profile,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.PROFILE_DETAIL,
    component: ProfileInformationDetail,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.ORDERS,
    component: ProfileOrders,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.ORDER_DETAIL,
    component: ProfileOrderDetail,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.PAYMENT_RETURN,
    component: PaymentReturn,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.LUCKY_WHEEL,
    component: LuckyWheel,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.LUCKY_WHEEL_SUMMARY,
    component: LuckyWheelSummary,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.EVENT_VOUCHER_LUCKY,
    component: VoucherLucky,
    exact: true,
    isLogged: false,
  },
  //TODO: Membership
  // {
  //   path: ROUTER_PATH.MEMBERSHIP,
  //   component: ProfileMembership,
  //   exact: true,
  //   isLogged: false,
  // },
  //TODO: Point histories
  // {
  //   path: ROUTER_PATH.POINT_HISTORIES,
  //   component: PointHistories,
  //   exact: true,
  //   isLogged: false,
  // },
  {
    path: ROUTER_PATH.PRODUCTS_WISH,
    component: ProfileProductWish,
    exact: true,
    isLogged: false,
  },
  {
    path: ROUTER_PATH.CHANGE_PASSWORD,
    component: Profile,
    exact: true,
    isLogged: false,
  },
];

_routes.push({
  component: PageNotFound,
  exact: true,
  isLogged: false,
  path: undefined,
});

const Routes = (props: any) => {
  return (
    <LocalizedSwitch>
      {_routes.map((r, i) => {
        return r.isLogged ? null : (
          // TODO : define router auth
          // <PrivateRouter
          //     {...props}
          //     key={i}
          //     component={r.component}
          //     path={r.path}
          //     exact={r.exact}
          //     isAdmin={r.isAdmin}
          // />

          <Route
            {...props}
            key={i}
            component={r.component}
            path={r.path}
            exact={r.exact}></Route>
        );
      })}
    </LocalizedSwitch>
  );
};

export default Routes;
